import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapLocation } from "@fortawesome/free-solid-svg-icons";

function Search(props) {
  const [query, setQuery] = useState({ state: "all", provider: "all" }); // by default, return projects from all states and providers

  const handleStateSelect = (evt) => {
    let updatedQuery = { state: evt.target.value };
    setQuery((query) => ({ ...query, ...updatedQuery }));
  };

  const handleProviderSelect = (evt) => {
    let updatedQuery = { provider: evt.target.value };
    setQuery((query) => ({ ...query, ...updatedQuery }));
  };

  const searchButtonClicked = () => {
    console.log("search button clicked! current query: ", query);
    props.searchButtonClicked(query);
  };

  return (
    <div className="container search-container">
      {/* search by state */}
      <>
        <Form.Group className="mb-3">
          <Row>
            <Col md={6} sm={12}>
              <Form.Label>
                <FontAwesomeIcon icon={faMapLocation} /> Select a state
              </Form.Label>
              <Form.Select onChange={handleStateSelect}>
                {props.usStates.map((state, index) => (
                  <option value={state} key={index}>
                    {state}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} sm={12}>
              <Form.Label>
                <FontAwesomeIcon icon={faSearch} /> Select a provider
              </Form.Label>
              <Form.Select onChange={handleProviderSelect}>
                {props.providers.map((provider, index) => (
                  <option value={provider} key={index}>
                    {provider}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button className="btn-hover color-2" onClick={searchButtonClicked}>
            Search
          </Button>
        </div>
      </>
    </div>
  );
}

export default Search;
